module.exports = __webpack_public_path__ + "img/vmd.a39402e6.svg";